import { check } from "@xams-utils/check-types";

const secondsToMinutes = (seconds) => {
    if (isNaN(seconds) || seconds < 0) {
        return "Invalid input";
    }

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return remainingSeconds === 0
        ? `${minutes} minute${minutes === 1 ? "" : "s"}`
        : `${minutes} minute${
              minutes === 1 ? "" : "s"
          } and ${remainingSeconds} seconds`;
};

const hasExtended = (extendable) => {
    return check.number(extendable) && extendable > 0;
};

export { secondsToMinutes, hasExtended };
